import { ComponentController } from "luxedo-reactivity"

type Links = {
	[index: string]: (() => void) | string
}

export class MobileOtherLinksController extends ComponentController<{ isOpen: boolean }> {
	LINKS: Links = $state({})

	constructor(links: Links) {
		super({ isOpen: false })
		this.LINKS = links
	}

	open = () => {
		this.ctx.isOpen = true
	}

	close = () => {
		this.ctx.isOpen = false
	}
}
